import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useTranslation } from '../i18n'
import { useAuth } from '../utils/auth'
import SEO from '../components/SEO'
import './AuthPages.css'

function RegisterPage() {
  const { t } = useTranslation()
  const { register } = useAuth()
  const navigate = useNavigate()

  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError('')

    if (password !== confirmPassword) {
      setError(t('registerPasswordMismatch'))
      return
    }

    setLoading(true)
    try {
      await register(email, password)
      navigate('/dashboard', { replace: true })
    } catch (err: unknown) {
      setError(err instanceof Error ? err.message : t('registerError'))
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="auth-page">
      <SEO
        title="Create Account"
        description="Create your free Intervio account. Start your free 1-hour trial with all features included."
        path="/register"
        noIndex
      />
      <div className="auth-card">
        <h1>{t('registerTitle')}</h1>
        <p className="auth-subtitle">{t('registerSubtitle')}</p>

        <form onSubmit={handleSubmit} className="auth-form">
          <div className="form-group">
            <label htmlFor="reg-email">{t('authEmail')}</label>
            <input
              id="reg-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder={t('authEmailPlaceholder')}
              required
              autoFocus
            />
          </div>

          <div className="form-group">
            <label htmlFor="reg-password">{t('authPassword')}</label>
            <input
              id="reg-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder={t('authPasswordPlaceholder')}
              required
              minLength={8}
            />
          </div>

          <div className="form-group">
            <label htmlFor="reg-confirm">{t('authConfirmPassword')}</label>
            <input
              id="reg-confirm"
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder={t('authConfirmPlaceholder')}
              required
              minLength={8}
            />
          </div>

          {error && <div className="auth-error">{error}</div>}

          <button
            type="submit"
            className="btn btn-primary btn-large auth-submit"
            disabled={loading}
          >
            {loading ? t('authCreatingAccount') : t('registerButton')}
          </button>

          <p className="auth-terms">{t('registerTerms')}</p>
        </form>

        <p className="auth-switch">
          {t('registerHaveAccount')}{' '}
          <Link to="/login">{t('registerSignInLink')}</Link>
        </p>
      </div>
    </div>
  )
}

export default RegisterPage
